$(function(){
  if($(".new-pdp-box-footer-price").length > 0 && $(".new-box-discount").length > 0){
    let disc = $(".new-box-discount.active").attr("data-discount");
    $(".new-pdp-box-footer-price").attr("data-discount", disc);
    if($(".new-pdp-box-footer-price dl").length > 0){
      $(".new-pdp-box-footer-price dl").text(`${disc}% Discount`);
    }
  }
})

$(document).on("click", ".new-box-discount", function(){
  $(".new-box-discount").removeClass("active");
  $(this).addClass("active");
  // let disc = $(this).attr("data-discount");
  // if($(".new-pdp-box-footer-price").length > 0){
  //   $(".new-pdp-box-footer-price").attr("data-discount", disc);
  // }
  // if($(".new-pdp-box-footer-price dl").length > 0){
  //   $(".new-pdp-box-footer-price dl").text(`${disc}% Discount`);
  // }
})

function updateActiveDiscount(quantity) {
  var disc = 0;
  var $discounts = $('.new-box-discount');
  var $sorted = $discounts.sort(function (a, b) {
    return $(a).data('count') - $(b).data('count');
  });
  $discounts.removeClass('active');
  var $matchedTier = null;
  $sorted.each(function () {
    var $tier = $(this);
    var count = parseInt($tier.data('count'), 10);
    if (quantity >= count) {
      $matchedTier = $tier;
    }
  });
  if (!$matchedTier && $sorted.length) {
    $matchedTier = $sorted.first();
  }
  $matchedTier.addClass('active');
  disc = parseInt($matchedTier.attr('data-discount'), 10);
  if ($('.new-pdp-box-footer-price').length > 0) {
    $('.new-pdp-box-footer-price').attr('data-discount', $matchedTier.attr('data-discount'));
  }
  if ($('.new-pdp-box-footer-price dl').length > 0) {
    if(quantity >= parseInt($discounts.eq(0).attr("data-count"))){
      $('.new-pdp-box-footer-price dl').show();
    }
    else{
      $('.new-pdp-box-footer-price dl').hide();
    }
    $('.new-pdp-box-footer-price dl').text(disc + '% Discount');
  }
  return disc;
}



$(document).on("click", ".new-pdp-prod-btn", function(){
  $(this).parents(".new-pdp-prod-card").addClass("active");
  $(this).parents(".new-pdp-prod-card").find(".new-pdp-prod-qty")[0].stepUp(1);
  updateBoxContent();
})

$(document).on("click", ".new-pdp-prod-qty-btn--plus", function(){
  $(this).parent().find(".new-pdp-prod-qty")[0].stepUp(1);
  updateBoxContent();
})

$(document).on("click", ".new-pdp-prod-qty-btn--minus", function(){
  $(this).parent().find(".new-pdp-prod-qty")[0].stepDown(1);
  updateBoxContent();
})

$(document).on("click", ".new-pdp-box-content-close", function(){
  $(`.new-pdp-prod-qty[data-id="${$(this).attr("data-id")}"]`).val(0);
  $(`.new-pdp-prod-qty[data-id="${$(this).attr("data-id")}"]`).parents(".new-pdp-prod-card").removeClass("active");
  updateBoxContent();
  $(this).remove();
})

$(document).on("click", ".new-pdp-box-header", function(){
  $(this).toggleClass("active");
  $(this).parents(".new-pdp-box-wrapper").find(".new-pdp-box-content-wrapper").toggleClass("active");
})

$(document).on("change", ".new-pdp-box-footer-selling-plan-select", function(){
  $(".new-pdp-box-footer-btn").attr("data-selling-plan", $(this).val());
  $(`.new-pdp-mobile-sp-inp[value="${$(this).val()}"]`)[0].checked = true;
})

function updateBoxContent(){
  let totalCount = 0;
  let totalPrice = parseFloat($(".new-pdp-box-footer-price").attr("data-price"));
  let moneyFormat = $(".new-pdp-box-footer-price").attr("data-money");
  let discount = parseInt($(".new-pdp-box-footer-price").attr("data-discount"));
  let limit = parseInt($(".new-pdp-wrapper").attr("data-limit"));
  $(".new-pdp-box-content-wrapper").empty();
  $(".new-pdp-prod-card.active").each(function(){
    let price = parseInt($(this).find(".new-pdp-prod-qty").val()) * parseFloat($(this).find(".new-pdp-prod-qty").attr("data-price"));
    let content = `<div class="new-pdp-box-content-item" data-id="${$(this).attr("data-id")}">
    <span class="new-pdp-box-content-close" data-id="${$(this).find(".new-pdp-prod-qty").attr("data-id")}">&#10005;</span>
    <img src="${$(this).find(".new-pdp-prod-card-img").attr("data-img")}" class="new-pdp-box-content-img" />
    <p class="new-pdp-box-content-title">${$(this).find(".new-pdp-prod-card-title").text()}
    <span>x ${$(this).find(".new-pdp-prod-qty").val()}</span>
    <span class="new-pdp-box-content-price">${Shopify.formatMoney(price, moneyFormat)}</span>
    </p>
    </div>`
    $(".new-pdp-box-content-wrapper").append(content);
    totalCount += parseInt($(this).find(".new-pdp-prod-qty").val());
    totalPrice += price;
  });
  $(".new-pdp-box-items-count").text(totalCount);
  discount = updateActiveDiscount(totalCount);
  if(discount > 0){
    let discountAmount = totalPrice * (discount / 100);
    let finalPrice = totalPrice - discountAmount;
    $(".new-pdp-box-footer-price strike").text(Shopify.formatMoney(totalPrice, moneyFormat));
    $(".new-pdp-box-footer-price em").text(Shopify.formatMoney(finalPrice, moneyFormat));
    $(".new-pdp-box-footer-price dd").text(Shopify.formatMoney(discountAmount, moneyFormat));
  }
  else{
   $(".new-pdp-box-footer-price em").text(Shopify.formatMoney(totalPrice, moneyFormat)); 
  }
  let requiredCount = parseInt(
    $(".new-box-discount").first().attr("data-count"),
    10
  ) || 0;

  if(totalCount >= requiredCount){
    $(".new-pdp-box-footer-btn")
      .addClass("active")
      .prop("disabled", false);
  }
  else{
    $(".new-pdp-box-footer-btn")
      .removeClass("active")
      .prop("disabled", true);
  }
}

function resetBoxContent(){
  $(".new-pdp-box-content-wrapper").empty();
  $(".new-pdp-prod-qty:not(.new-pdp-prod-qty--chef)").val(0);
  $(".new-pdp-prod-card").removeClass("active");
  $(".new-pdp-prod-card").removeClass("disabled");
}

$(document).on("change", ".new-pdp-box-choice-input", function(){
  resetBoxContent();
  if($(this).val() == 'chef-choice'){
    $(".new-pdp-products-wrapper--chef .new-pdp-prod-card").addClass("active");
    // $(".new-pdp-products-wrapper--chef .new-pdp-prod-qty").val(1);
  }
  updateBoxContent();
  if($(this).val() == 'chef-choice'){
    $(".new-pdp-box-content-close").remove();
  }
})

$(document).on("click", ".new-pdp-box-footer-btn.active", function(){
  let $this = $(this);
  let arr = [];
  $this.addClass("active-loading");
  
  // ⭐ ADD THE EXTRA PRODUCT FIRST (ID: 40914461425700)
  // This product will be added but hidden from the cart drawer
  arr.push({
    'id': 40914461425700,
    'quantity': 1,
    'properties': {
      '_hidden': 'true'  // Custom property to identify this product
    }
  });
  
  if($(this).attr("data-selling-plan") != "none"){
    $(".new-pdp-prod-card.active").each(function(){
      arr.push({
        'id': $(this).attr("data-id"),
        'quantity': parseInt($(this).find(".new-pdp-prod-qty").val()),
        'selling_plan': $this.attr("data-selling-plan")
      })
    })
  }
  else{
    $(".new-pdp-prod-card.active").each(function(){
      arr.push({
        'id': $(this).attr("data-id"),
        'quantity': parseInt($(this).find(".new-pdp-prod-qty").val())
      })
    })
  }
  
  let formData = {
    'items': arr,
    sections: "cart-drawer,cart-icon-bubble"
  };
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      console.log('Resetting build your box');

        // Remove selected products
        $('.new-pdp-box-content-wrapper').empty();
        $('.new-pdp-prod-card').removeClass('active');
        $('.new-pdp-prod-qty').val('0').text('0');

       // Reset all prices
        $('.new-pdp-box-footer-price')
          .attr('data-price', '0');

        $('.new-pdp-box-footer-price strike').text('$0.00');
        $('.new-pdp-box-footer-price em').text('$0.00');
        $('.new-pdp-box-footer-price i').empty();
        $('.new-pdp-box-footer-price dl').empty().hide();
        $('.new-pdp-box-items-count').text('0');

        // Activate only the first meal plan
        $('.new-box-discount')
          .removeClass('active')
          .first()
          .addClass('active');

        // Reset selected plan data
        $('.new-pdp-box-footer-price')
          .attr('data-price', '0')
          .attr('data-discount', '5');

        // Disable Proceed button
        $('.new-pdp-box-footer-btn').prop('disabled', true).removeClass('active');
   
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      
      // ⭐ REMOVE THE EXTRA PRODUCT FROM CART DRAWER BEFORE DISPLAYING
      // Find all cart items with variant ID 40914461425700 and remove them
      // $(cartParsedData).find('cart-drawer-items').find('cart-drawer-item, .cart-item, [data-index]').each(function() {
      //   let $item = $(this);
      //   let itemHtml = $item.html();
        
      //   // Check multiple ways the variant ID might appear
      //   if (itemHtml && (
      //       itemHtml.includes('40914461425700') || 
      //       itemHtml.includes('variants/40914461425700') ||
      //       $item.attr('data-variant-id') === '40914461425700' ||
      //       $item.find('[data-variant-id="40914461425700"]').length > 0 ||
      //       $item.find('a[href*="40914461425700"]').length > 0
      //   )) {
      //     $item.remove(); // Remove this item completely
      //   }
      // });
      
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
      
      document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
      $(".cart-count-bubble").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active-loading");
  });
})

$(document).on("click", ".new-pdp-choice-mobile-wrapper span", function(){
  $(".new-pdp-choice-mobile-wrapper span").removeClass("active");
  $(this).addClass("active");
  let id = $(this).attr("data-id");
  if(id == 1){
    $(`label[for="new-pdp-my-choice"]`).trigger("click");
  }
  else{
    $(`label[for="new-pdp-chef-choice"]`).trigger("click");
  }
})

$(document).on("change", ".new-pdp-mobile-sp-inp", function(){
  $(".new-pdp-box-footer-btn").attr("data-selling-plan", $(this).val());
  $(this).parents(".new-pdp").find(".page-width > .new-pdp-mobile-sp-wrapper").find(`.new-pdp-mobile-sp-inp`).removeClass("active");
  $(this).parents(".new-pdp").find(".page-width > .new-pdp-mobile-sp-wrapper").find(`.new-pdp-mobile-sp-inp[value="${$(this).val()}"]`).addClass("active");
})

$(document).on("click", ".cc__columnitemcontainer-item-link", function(e){
  if($(window).width() <= 480){
    e.preventDefault();
    $(".cc__columnitemcontainer-item-link").removeClass("new-act");
    $(this).addClass("new-act");
    $(".new-stick-multi-btn").removeClass("inactive");
    $(".new-stick-multi-btn span").text($(this).attr("data-title"));
  }
})

$(document).on("click", ".new-stick-multi-btn", function(){
  location.href = $(".cc__columnitemcontainer-item-link.new-act").attr("href");
})


function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}


$(document).on("input", ".new-blog-search-inp", debounce(function(){
  let query = $(this).val().trim();
  if(query.length > 0){
    $(".new-blog-right").hide();
    $(".new-blog-right-search-results").addClass("active").addClass("new-load").empty();
    $.ajax({
      type: "GET",
      url: `/search?q=${encodeURIComponent(query)}&view=ajax`,
      success: function(result){
        $(".new-blog-right-search-results").html(result).removeClass("new-load");
      }
    });
  }
  else{
    $(".new-blog-right-search-results").removeClass("active").empty();
    $(".new-blog-right").show();
  }
}, 500));


$(document).on("change", ".new-blog-menu-select", function(){
  let url = $(this).find("option:selected").attr("data-url");
  if(url){
    window.location.href = url;
  }
});


$(document).on("click", ".new-hero-zip-btn", function(e){
  let val = $(this).parent().find(".new-hero-zip-input").val().trim();
  let localZips = [
    89431, 89433, 89434, 89436, 89441, 89501, 89502, 89521,
    89439, 89503, 89506, 89508, 89509, 89511, 89512, 89519, 89523
  ];
  console.log(val.length);
  if(val.length !== 5 || isNaN(val)){
    alert("Please enter a valid 5-digit ZIP code.");
    return
  }
  if(localZips.includes(parseInt(val))){
    // localStorage.setItem('buildabox_zip', val);
    let time = parseInt(document.querySelector("body").getAttribute("data-expire"));
    Cookies.set('buildabox_zip', val, { expires: time });
    if(location.href.indexOf('?redirect-from-pdp') != -1){
      location.href = '/products/60-pack';
    }
    else{
      location.href = "/collections/build-a-box?new-hero-redirect=yes";
    }
  }
  else{
    // localStorage.setItem('buildabox_zip', val);
    let time = parseInt(document.querySelector("body").getAttribute("data-expire"));
    Cookies.set('buildabox_zip', val, { expires: time });
    if(location.href.indexOf('?redirect-from-pdp') != -1){
      location.href = '/products/60-pack-nation-wide';
    }
    else{
      location.href = "/collections/build-a-box?new-hero-redirect=yes";
    }
  }
})
/* =========================================
   NEW MULTI SELECT PRODUCT FILTERS
========================================= */


/* =========================================
   UPDATE / APPLY FILTER RESULTS
========================================= */

function updateNewBoxFilters($module) {

  let scope = $module.attr('data-filter-scope');

  let $grid = $(
    '.new-pdp-products-wrapper[data-filter-grid="' + scope + '"]'
  );

  let $cards = $grid.find('.new-pdp-prod-card');

  let activeGroups = [];


  /* =========================================
     BUILD APPLIED FILTER GROUPS

     Same group = OR

     Chicken + Beef
     =
     Chicken OR Beef

     Different groups = AND

     (Chicken OR Beef)
     AND
     Gluten-Free
  ========================================= */

  $module.find('.new-box-filter-group').each(function () {

    let groupValues = [];

    $(this)
      .find('.new-box-filter-option.applied')
      .each(function () {

        let value = String(
          $(this).attr('data-value') || ''
        )
          .trim()
          .toLowerCase();

        if (value) {
          groupValues.push(value);
        }

      });


    if (groupValues.length > 0) {
      activeGroups.push(groupValues);
    }

  });


  let visibleCount = 0;


  /* =========================================
     FILTER PRODUCTS
  ========================================= */

  $cards.each(function () {

    let $card = $(this);

    let tags = String(
      $card.attr('data-tags') || ''
    )
      .split(',')
      .map(function (tag) {
        return tag.trim().toLowerCase();
      })
      .filter(Boolean);


    let isMatch = activeGroups.every(function (groupValues) {

      return groupValues.some(function (filterValue) {

        return tags.indexOf(filterValue) !== -1;

      });

    });


    $card.toggle(isMatch);


    if (isMatch) {
      visibleCount++;
    }

  });


  /* =========================================
     UPDATE MEAL COUNT
  ========================================= */

  $module
    .find('.new-box-filter-meals-count')
    .text(
      visibleCount +
      (visibleCount === 1 ? ' meal' : ' meals')
    );


  /* =========================================
     APPLIED FILTER COUNT
  ========================================= */

  let selectedCount = $module
    .find('.new-box-filter-option.applied')
    .length;


  if (selectedCount > 0) {

    $module
      .find('.new-box-filter-open-count')
      .text('(' + selectedCount + ')');

    $module.addClass('has-active-filters');

  } else {

    $module
      .find('.new-box-filter-open-count')
      .text('');

    $module.removeClass('has-active-filters');

  }


  /* =========================================
     SELECTED FILTER PILLS
  ========================================= */

  let $selectedWrapper = $module.find(
    '.new-box-filter-selected'
  );

  $selectedWrapper.empty();


  $module
    .find('.new-box-filter-option.applied')
    .each(function () {

      let $option = $(this);

      let label = $option.attr('data-label');
      let value = $option.attr('data-value');

      let group = $option
        .closest('.new-box-filter-group')
        .attr('data-filter-group');


      let $chip = $('<button>', {
        type: 'button',
        class: 'new-box-selected-filter'
      });


      $chip.text(label + ' ×');

      $chip.attr({
        'data-value': value,
        'data-group': group
      });


      $selectedWrapper.append($chip);

    });

}



/* =========================================
   SELECT / DESELECT OPTION

   IMPORTANT:
   This does NOT filter immediately.
========================================= */

$(document).on(
  'click',
  '.new-box-filter-option',
  function (e) {

    e.preventDefault();

    let $option = $(this);

    $option.toggleClass('active');


    $option.attr(
      'aria-pressed',
      $option.hasClass('active')
        ? 'true'
        : 'false'
    );

  }
);



/* =========================================
   RESTORE DRAWER TO CURRENTLY
   APPLIED FILTERS
========================================= */

function restorePendingFilters($module) {

  $module
    .find('.new-box-filter-option')
    .removeClass('active')
    .attr('aria-pressed', 'false');


  $module
    .find('.new-box-filter-option.applied')
    .addClass('active')
    .attr('aria-pressed', 'true');

}



/* =========================================
   OPEN FILTER DRAWER
========================================= */

$(document).on(
  'click',
  '.new-box-filter-open',
  function (e) {

    e.preventDefault();

    let $module = $(this).closest(
      '.new-box-filter-module'
    );


    /* Close any other open filter drawer */
    $('.new-box-filter-module.filter-open')
      .not($module)
      .each(function () {

        let $otherModule = $(this);

        restorePendingFilters($otherModule);

        $otherModule.removeClass('filter-open');

      });


    /* Restore current applied state */
    restorePendingFilters($module);


    $module.addClass('filter-open');

    $('body').addClass(
      'new-box-filter-body-open'
    );

  }
);



/* =========================================
   CLOSE FUNCTION
========================================= */

function closeNewBoxFilter($module, restoreSelections = true) {

  if (restoreSelections) {
    restorePendingFilters($module);
  }


  $module.removeClass('filter-open');


  if (
    $('.new-box-filter-module.filter-open').length === 0
  ) {

    $('body').removeClass(
      'new-box-filter-body-open'
    );

  }

}


$(document).on('click.newBoxFilterOutside', function(e) {

  $('.new-box-filter-module.filter-open').each(function() {

    let $module = $(this);

    // If click is INSIDE the drawer, do nothing
    if ($(e.target).closest('.new-box-filter-drawer').length) {
      return;
    }

    // If click is on the Filters open button, do nothing
    if ($(e.target).closest('.new-box-filter-open').length) {
      return;
    }

    // Otherwise it is an outside click
    closeNewBoxFilter($module, true);

  });

});



/* =========================================
   CLOSE X BUTTON
========================================= */

$(document).on(
  'click',
  '.new-box-filter-close',
  function (e) {

    e.preventDefault();

    let $module = $(this).closest(
      '.new-box-filter-module'
    );

    closeNewBoxFilter($module, true);

  }
);



/* =========================================
   CLICK OUTSIDE / OVERLAY TO CLOSE

   Works desktop + mobile
========================================= */

$(document).on(
  'click',
  '.new-box-filter-overlay',
  function (e) {

    e.preventDefault();

    let $module = $(this).closest(
      '.new-box-filter-module'
    );

    closeNewBoxFilter($module, true);

  }
);



/* =========================================
   APPLY FILTERS
========================================= */

$(document).on(
  'click',
  '.new-box-filter-apply',
  function (e) {

    e.preventDefault();

    let $module = $(this).closest(
      '.new-box-filter-module'
    );


    /* Remove previously applied filters */
    $module
      .find('.new-box-filter-option')
      .removeClass('applied');


    /* Make current drawer selections applied */
    $module
      .find('.new-box-filter-option.active')
      .addClass('applied');


    /* NOW update product grid */
    updateNewBoxFilters($module);


    /* Close without reverting selections */
    closeNewBoxFilter($module, false);

  }
);



/* =========================================
   RESET FILTER

   Immediately clears everything
   and fixes product count.
========================================= */

$(document).on(
  'click',
  '.new-box-filter-reset',
  function (e) {

    e.preventDefault();

    let $module = $(this).closest(
      '.new-box-filter-module'
    );


    $module
      .find('.new-box-filter-option')
      .removeClass('active applied')
      .attr('aria-pressed', 'false');


    /* Immediately restore full product grid */
    updateNewBoxFilters($module);

  }
);



/* =========================================
   CLEAR ALL ABOVE PRODUCT GRID

   Immediately resets everything.
========================================= */

$(document).on(
  'click',
  '.new-box-filter-clear-all',
  function (e) {

    e.preventDefault();

    let $module = $(this).closest(
      '.new-box-filter-module'
    );


    $module
      .find('.new-box-filter-option')
      .removeClass('active applied')
      .attr('aria-pressed', 'false');


    updateNewBoxFilters($module);

  }
);



/* =========================================
   REMOVE ONE SELECTED FILTER PILL
========================================= */

$(document).on(
  'click',
  '.new-box-selected-filter',
  function (e) {

    e.preventDefault();

    let $chip = $(this);

    let $module = $chip.closest(
      '.new-box-filter-module'
    );

    let value = $chip.attr('data-value');
    let group = $chip.attr('data-group');


    $module
      .find(
        '.new-box-filter-group[data-filter-group="' +
        group +
        '"] .new-box-filter-option'
      )
      .filter(function () {

        return (
          $(this).attr('data-value') === value
        );

      })
      .removeClass('active applied')
      .attr('aria-pressed', 'false');


    updateNewBoxFilters($module);

  }
);



/* =========================================
   ESCAPE KEY CLOSE
========================================= */

$(document).on(
  'keydown',
  function (e) {

    if (e.key !== 'Escape') {
      return;
    }


    $('.new-box-filter-module.filter-open')
      .each(function () {

        closeNewBoxFilter(
          $(this),
          true
        );

      });

  }
);



/* =========================================
   INITIAL COUNTS
========================================= */

function initNewBoxFilters() {

  $('.new-box-filter-module')
    .each(function () {

      updateNewBoxFilters(
        $(this)
      );

    });

}


$(function () {

  initNewBoxFilters();

});